module.exports = __webpack_public_path__ + "static/flags/JE-fce0c7295e92a483bbfc03d867034420.gif";